import React from 'react'
import './footer.css'
import Contact from '../forms/Contact'
import Logo from '../../img/logo1.png'
import { FiInstagram } from 'react-icons/fi'

const Footer = () => {
  return (
    <footer>
      <div className="mainFooter">
        <div className='titles'>
          <ul>
            <li>
              <a href="#Home">Home</a>
            </li>
            <li>
              <a href="#Projects">Project</a>
            </li>
            <li>
              <a href="#Services">Services</a>
            </li>
            <li>
              <a href="#Clients">Clients</a>
            </li>
          </ul>
        </div>

        <div className='titles'>
          <ul>
            
            <li>Contact us<br></br>
              5663 nw 35th court Miami FL 33142<br></br>
              13475 Reeder rd. Forney Texas 75126<br></br>
              (305) 680-2062<br></br>
              infocontinentalmetalwork@gmail.com             
            </li>
          </ul>
        </div>

        <div className="contactForm">
          <img src={Logo} />
          <Contact />
        </div>
      </div>

      <div className="footerCredits">

        <div className="footer__copyright">
          <p>&copy; All rights reserved. <em>Continental Iron Work</em></p>
        </div>

        <div className="footer__socials">
          <a href="https://www.instagram.com/continental_iron_work?igsh=ZzdnMW02aXJqcTd4"><FiInstagram /></a>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 